// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: asr.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Struct } from "./google/protobuf/struct";

export const protobufPackage = "asr";

export interface Asr {
  providerId: string;
  modelId: string;
  language: string;
  config: { [key: string]: any } | undefined;
}

function createBaseAsr(): Asr {
  return { providerId: "", modelId: "", language: "", config: undefined };
}

export const Asr: MessageFns<Asr> = {
  encode(message: Asr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.providerId !== "") {
      writer.uint32(10).string(message.providerId);
    }
    if (message.modelId !== "") {
      writer.uint32(18).string(message.modelId);
    }
    if (message.language !== "") {
      writer.uint32(26).string(message.language);
    }
    if (message.config !== undefined) {
      Struct.encode(Struct.wrap(message.config), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Asr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAsr();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Asr {
    return {
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      language: isSet(object.language) ? globalThis.String(object.language) : "",
      config: isObject(object.config) ? object.config : undefined,
    };
  },

  toJSON(message: Asr): unknown {
    const obj: any = {};
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.language !== "") {
      obj.language = message.language;
    }
    if (message.config !== undefined) {
      obj.config = message.config;
    }
    return obj;
  },

  create(base?: DeepPartial<Asr>): Asr {
    return Asr.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Asr>): Asr {
    const message = createBaseAsr();
    message.providerId = object.providerId ?? "";
    message.modelId = object.modelId ?? "";
    message.language = object.language ?? "";
    message.config = object.config ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
